export const NUMBERS = "decimal";
export const UPPER_CASE_LETTERS = "upper-alpha";
export const LOWER_CASE_LETTERS = "lower-alpha";
export const UPPER_CASE_ROMAN = "upper-roman";
export const LOWER_CASE_ROMAN = "lower-roman";